// import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from 'react-select';
import { Checkbox } from '@mui/material';
// import MDInput from "components/MDInput";
import * as service from '../../services/service';

function LegalAdvisorAllocations() {
    const [data, setData] = useState([]);
    const [legalAdvisorData, setLegalAdvisorData] = useState([]);
    const [legalAdvisorId, setLegalAdvisorId] = useState('');
    const [courtData, setCourtData] = useState([]);
    const [caseTypeData, setCaseTypeData] = useState([]);
    const [courtId, setCourtId] = useState('');
    const [caseTypeId, setCaseTypeId] = useState('');
    const [districtIds, setDistrictsIds] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    // const navigate = useNavigate();

    const getCourts = () => {
        fetch(
            service.COURTS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.courtId, label: item.court }));
                setCourtData(data2);
            });
    };

    const getCaseTypes = (id) => {
        fetch(
            service.GET_CASE_TYPE_BY_COURT_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CourtId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.caseTypeId, label: item.caseType }));
                setCaseTypeData(data2);
            });
    };

    const getLegalAdvisors = () => {
        fetch(
            service.GET_LEGAL_ADVISORS,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.userId, label: item.fullName }));
                setLegalAdvisorData(data2);
            });
    };

    const getDetails = (id) => {
        if (id > 0) {
            fetch(
                service.GET_LEGAL_ADVISOR_ALLOCATIONS,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CourtId: courtId.value,
                        CaseTypeId: caseTypeId.value,
                        UserId: id
                    })
                })
                .then(res => res.json())
                .then(result => {
                    setData(result);
                    result.forEach((element, index) => {
                        districtIds[index] = element.districtId;
                        setDistrictsIds([...districtIds]);
                        isSelected[index] = element.isSelected;
                        setIsSelected([...isSelected]);
                    });
                })
                .catch(err => {
                    if (err) {
                        setErrors(err);
                    };
                });
        }
    };
    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!legalAdvisorId) {
            isValid = false;
            errs[".legalAdvisorId"] = "Please select legal advisor";
        }
        if (!courtId) {
            isValid = false;
            errs[".courtId"] = "Please select court";
        }
        if (!caseTypeId) {
            isValid = false;
            errs[".caseTypeId"] = "Please select case type";
        }
        if (!isSelected.includes(true)) {
            isValid = false;
            errs[".districtId"] = "Please select district";
        }
        setErrors(errs);
        return isValid;
    }

    const submitHandler = e => {
        if (validate()) {
            // eslint-disable-next-line
            console.log(districtIds); // do not remove
            e.preventDefault();
            const errs = {};
            setLoading(true);
            let flag = true;
            fetch(
                service.DELETE_LEGAL_ADVISOR_ALLOCATIONS,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CourtId: courtId.value,
                        CaseTypeId: caseTypeId.value,
                        UserId: legalAdvisorId.value
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        // navigate('/supplier/suppliermaterialmap');
                    }
                    else if (result.messageType === 'Success') {
                        districtIds.forEach((element, index) => {
                            if (isSelected[index] === true) {
                                fetch(
                                    service.ADD_LEGAL_ADVISOR_ALLOCATION,
                                    {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({
                                            CourtId: courtId.value,
                                            CaseTypeId: caseTypeId.value,
                                            UserId: legalAdvisorId.value,
                                            DistrictId: element,
                                            AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                                        })
                                    })
                                    .then(resp => resp.json())
                                    .then(respo => {
                                        if (respo.messageType === 'Failed') {
                                            flag = false;
                                            // eslint-disable-next-line
                                            alert(respo.message);
                                            // navigate('/supplier/suppliermaterialmap');
                                        }
                                        else {
                                            flag = false;
                                            errs[".invalid"] = respo.message.message;
                                            setErrors(errs);
                                        }
                                    });
                            }
                        });
                        if (flag) {
                            // eslint-disable-next-line
                            alert("Data Saved Successfully");
                            // navigate('/masters/operationmachinemap');
                            window.location.reload(false);
                        }
                    }
                });
            setLoading(false);
        }
    }

    const legalAdvisorChangeHandler = (ev) => {
        setLegalAdvisorId(ev);
        setData([]);
        setDistrictsIds([]);
        setIsSelected([]);
        getDetails(ev.value);
    }
    const courtChangeHandler = (ev) => {
        setCourtId(ev);
        setCaseTypeId(null);
        getCaseTypes(ev.value);
        setData([]);
        setDistrictsIds([]);
        setIsSelected([]);
    }
    const caseTypeChangeHandler = (ev) => {
        setCaseTypeId(ev);
        setData([]);
        setDistrictsIds([]);
        setIsSelected([]);
    }
    useEffect(() => {
        setLoading(true);
        getCourts();
        getLegalAdvisors();
        setLoading(false);
    }, []);

    const handleCheckboxChange = (checked, index) => {
        let updatedObject = isSelected[index];
        updatedObject = checked;
        isSelected[index] = updatedObject;
        setIsSelected([...isSelected]);
    }

    const clearHandler = () => {
        setLegalAdvisorId(null);
        setCourtId(null);
        setCaseTypeId(null);
        setData([]);
        setDistrictsIds([]);
        setIsSelected([]);
        setErrors('');
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Legal Advisor Allocation
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>

                                <Table aria-label="simple table">
                                    <TableRow>
                                        <TableCell align='right' style={{ fontSize: '12px', width: '20%' }}>Court :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '25%' }}>
                                            <Select
                                                options={courtData}
                                                name="court"
                                                value={courtId}
                                                onChange={courtChangeHandler}
                                                placeholder="Select Court"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".courtId"]}</div>
                                        </TableCell>
                                        <TableCell align='right' style={{ fontSize: '12px', width: '20%' }}>Case Type :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '25%' }}>
                                            <Select
                                                options={caseTypeData}
                                                name="caseType"
                                                value={caseTypeId}
                                                onChange={caseTypeChangeHandler}
                                                placeholder="Select Case Type"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseTypeId"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align='right' style={{ fontSize: '12px' }}>Legal Advisor :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px' }}>
                                            <Select
                                                options={legalAdvisorData}
                                                name="legalAdvisor"
                                                value={legalAdvisorId}
                                                onChange={legalAdvisorChangeHandler}
                                                placeholder="Select Legal Advisor"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".legalAdvisorId"]}</div>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <br />
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>District</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row, index) => (
                                                    <TableRow
                                                        key={row.districtId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>
                                                            <Checkbox checked={isSelected[index] || false}
                                                                onChange={(e) => handleCheckboxChange(e.target.checked, index)} id="chkSelect" />
                                                        </TableCell>
                                                        <TableCell>{row.district}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".districtId"]}</div>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={clearHandler}>
                                                Clear
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default LegalAdvisorAllocations;